import { ITransfersGenericData, ITransfersGenericTableData } from '.';
import { IListingData } from '@models/listing';
import { lookupListAsRecordObject } from '@utils/graph-utils';

export function mapToListingData(data: any): IListingData {
  const list: Record<string, ITransfersGenericTableData> = {};
  data.Accounting.queries.TransfersList?.items?.forEach(
    (obj: ITransfersGenericData, i: number) => {
      list[i] = {
        Accounting_AccountingTransfers_Id:
          obj.accounting_AccountingTransfers_Id,
        Accounting_AccountingTransfers_RelatedCompany:
          obj.accounting_AccountingTransfers_RelatedCompany.id,
        Accounting_AccountingTransfers_TransferMonth:
          obj.accounting_AccountingTransfers_TransferMonth,
        Accounting_AccountingTransfers_TransferNumber:
          obj.accounting_AccountingTransfers_TransferNumber,
        Accounting_AccountingTransfers_TransferPeriodFrom:
          obj.accounting_AccountingTransfers_TransferPeriodFrom,
        Accounting_AccountingTransfers_TransferPeriodTo:
          obj.accounting_AccountingTransfers_TransferPeriodTo,
        Accounting_AccountingTransfers_TransferType:
          obj.accounting_AccountingTransfers_TransferType.Title,
        Accounting_AccountingTransfers_TransferYear:
          obj.accounting_AccountingTransfers_TransferYear,
        Accounting_AccountingTransfers_createdOn:
          obj.accounting_AccountingTransfers_createdOn,
        Accounting_AccountingTransfers_modifiedOn:
          obj.accounting_AccountingTransfers_modifiedOn,
      };
    }
  );

  return {
    pagedItems: list,
    pageSize: data.Accounting.queries.TransfersList?.paging.pageSize,
    pageNumber: data.Accounting.queries.TransfersList?.paging.pageNumber,
    totalCount: data.Accounting.queries.TransfersList?.paging.totalCount,
  };
}

export function toLookupsData(data: any) {
  const lovs: Record<string, Record<string, string>> = {
    company: {},
    Type: {},
  };

  lovs.company = lookupListAsRecordObject(
    data?.SalesforceManagement?.lookups?.relatedCompanies
  );

  lovs.Type = lookupListAsRecordObject(data?.Accounting?.lookups?.transferType);

  return lovs;
}
